import { render } from "./OrderSummaryCard.vue?vue&type=template&id=c66293c2"
import script from "./OrderSummaryCard.vue?vue&type=script&lang=js"
export * from "./OrderSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__